/**
 * Settings Modal for VariationImgChats
 * Migrated to use shared SettingsModal pattern
 * Before: 115 lines | After: ~30 lines
 */
import { FC } from 'react';

import { DIVIDERS } from '.';
import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      ...WATERMARK_SECTIONS,
      {
        title: 'Text Position',
        type: 'radio',
        stateKey: 'divider',
        options: DIVIDERS,
      },
    ]}
  />
);

export default SettingsModal;
